import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { useApi, useToaster } from "@shopexperts/shared";
import type { SwitchExpertTypeRequest } from "@shopexperts/legacy-api";

export function useExpertTypeSwitch() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  const switchExpertType = useMutation({
    mutationFn: async ({
      expertId,
      body,
    }: {
      expertId: number;
      body: SwitchExpertTypeRequest;
    }) => {
      return await api.admin.expert.switchType({
        params: { expertId },
        body,
      });
    },
    onSuccess: (data) => {
      toaster.create({
        title: `Expert type switched to ${data.current_listing_type.replace(/_/g, " ")}`,
        type: "success",
      });
      queryClient.invalidateQueries({ queryKey: ["admin", "experts"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert"] });
    },
    onError: (error: Error) => {
      toaster.create({
        title: `Failed to switch expert type: ${error.message}`,
        type: "error",
      });
    },
  });

  return { switchExpertType };
}
